export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/879af3dcff1148646f553981f28abf2f.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top blur-sm"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-white/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-8 text-center">
        <div className="inline-block mb-6 px-4 py-1.5 bg-white/10 backdrop-blur-md rounded-full border border-white/20">
          <span className="text-sm text-white font-medium">여성을 위한 안전한 플랫폼</span>
        </div>
        
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-5 leading-tight tracking-tight">
          안심 커뮤니티 + 밤에 일하는<br />알바까지 한눈에
        </h1>
        
        <p className="text-lg text-white/90 mb-10 font-normal">
          여성 인증 후, 지역별로 바로 확인할 수 있어요
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a 
            href="https://onnyjob.kr/login"
            className="bg-purple-600 text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-purple-700 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            지금 시작하기
          </a>
          <button className="bg-white/10 backdrop-blur-md text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-white/20 transition-all duration-300 border border-white/30 whitespace-nowrap">
            더 알아보기
          </button>
        </div>

        {/* Trust Indicators */}
        <div className="mt-14 flex flex-wrap items-center justify-center gap-8 text-white/80">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-shield-check-line text-xl text-purple-300"></i>
            </div>
            <span className="text-sm font-medium">여성 인증 시스템</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-map-pin-line text-xl text-purple-300"></i>
            </div>
            <span className="text-sm font-medium">지역별 맞춤 정보</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-community-line text-xl text-purple-300"></i>
            </div>
            <span className="text-sm font-medium">안전한 커뮤니티</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-white/60 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}